import { Inject } from '@angular/core';
import { ErrorHandlerOptions, SentryErrorHandler } from '@sentry/angular-ivy';
import * as Sentry from '@sentry/angular-ivy';
import { environment } from '../environments/environment';

export class SentryCustomErrorHandler extends SentryErrorHandler {
  constructor(@Inject('errorConfig') config: ErrorHandlerOptions) {
    super(config);
  }

  public override handleError(error: unknown): void {
    Sentry.captureException(error, {
      tags: {
        online: navigator.onLine,
        version: environment.version,
      },
    });
    const chunkFailedMessage = /Loading chunk [\d]+ failed/;
    if (
      error &&
      (error as Error).message?.indexOf('Failed to load resource: the server responded with a status of 403') !== -1
    ) {
      // eslint-disable-next-line no-console
      console.log(
        $localize`Your session seems expired. Please reload the application by hitting the Reload button in the menu.`,
      );
      if (navigator.onLine) {
        this.reloadApp();
      }
      return;
    }

    if (
      error &&
      (error === 'The user is not authenticated' ||
        (error as Error).message?.indexOf('The user is not authenticated') !== -1)
    ) {
      // eslint-disable-next-line no-console
      console.log(
        $localize`You are not logged in. Please reload the application by hitting the Reload button in the menu.`,
      );
      if (navigator.onLine) {
        this.reloadApp();
      }
      return;
    }
    if (error && (error === 'No current user' || (error as Error).message?.indexOf('No current user') !== -1)) {
      // eslint-disable-next-line no-console
      console.log(
        $localize`You are not logged in. Please reload the application by hitting the Reload button in the menu.`,
      );
      if (navigator.onLine) {
        this.reloadApp();
      }
      return;
    }
    if (error && (error as Error).message?.indexOf('Invalid login token') !== -1) {
      // eslint-disable-next-line no-console
      console.log(
        $localize`You are not logged in. Please reload the application by hitting the Reload button in the menu.`,
      );
      if (navigator.onLine) {
        this.reloadApp();
      }
      return;
    }
    // eslint-disable-next-line no-console
    console.error('SentryCustomErrorHandler - ', error);
    super.handleError(error);
  }

  private reloadApp(): void {
    navigator.serviceWorker
      .getRegistrations()
      .then((registrations) => {
        Promise.all(registrations.map((r) => r.unregister()))
          .then(() => {
            if (navigator.onLine) {
              window.location.reload();
            }
          })
          .catch((error) => {
            // eslint-disable-next-line no-console
            console.error(error);
            if (navigator.onLine) {
              window.location.reload();
            }
          });
      })
      .catch((error) => {
        // eslint-disable-next-line no-console
        console.error(error);
        if (navigator.onLine) {
          window.location.reload();
        }
      });
  }
}

export function createSentryCustomErrorHandler(config: ErrorHandlerOptions): SentryErrorHandler {
  return new SentryCustomErrorHandler(config);
}
